import { takeEvery } from 'redux-saga/effects';

import * as basketActions from 'store/modules/basket';
import { removeExtra } from './utils';

export default function* listenRemoveExtra() {
  yield takeEvery(basketActions.removeExtra.toString(), removeExtra);
}
